<template>
  <option :value="getValue">{{getValue}}</option>
</template>

<script>
  export default {
    name: "selectOptions",
    props:{
      val : String,
    },
    computed: {
      getValue() {
        return this.val
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/selectOptions.vue